var _path, _path2;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgHome(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 24,
    height: 24,
    viewBox: "0 0 24 24",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M1.5 9L11.371 1.009C11.549 0.864982 11.771 0.786407 12 0.786407C12.229 0.786407 12.451 0.864982 12.629 1.009L22.5 9",
    stroke: "#040C1E",
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M11.363 5.026L2.885 12.026C2.65565 12.239 2.51767 12.5325 2.5 12.845V22.5C2.5 22.7652 2.60536 23.0196 2.79289 23.2071C2.98043 23.3946 3.23478 23.5 3.5 23.5H9.5V16C9.5 15.8674 9.55268 15.7402 9.64645 15.6464C9.74021 15.5527 9.86739 15.5 10 15.5H14C14.1326 15.5 14.2598 15.5527 14.3536 15.6464C14.4473 15.7402 14.5 15.8674 14.5 16V23.5H20.5C20.7652 23.5 21.0196 23.3946 21.2071 23.2071C21.3946 23.0196 21.5 22.7652 21.5 22.5V12.848C21.4823 12.5355 21.3444 12.242 21.115 12.029L12.637 5.029C12.4581 4.88047 12.2331 4.79891 12.0005 4.79837C11.768 4.79782 11.5426 4.87831 11.363 5.026Z",
    stroke: "#040C1E",
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgHome);
export default __webpack_public_path__ + "static/media/Home.2cf99788f88131966da2b703c0c19a80.svg";
export { ForwardRef as ReactComponent };